import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getBaseUrl } from "../config";
import { getAuthApiHeaders } from "../../utils/common";
import { showSnackbar } from "./snackbar";
import { getApiErrorMessage } from "../../utils/apiError";
import secureLocalStorage from "react-secure-storage";
const baseUrl = getBaseUrl();

export const exportToExcelApi = createAsyncThunk(
  "export-to-excel",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/user_session/${payload.sessionId}/tabular_response`,
        payload.data,
        {
          headers: {
            "Content-Type": "application/json",
            "use-case": "src",
            ...getAuthApiHeaders({ includeIncomingEmail: true }),
          },
          responseType: "blob",
          withCredentials: true,
        },
      );
      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Failed to load!", severity: "error" }));
      return rejectWithValue(getApiErrorMessage(error));
    }
  },
);

const exportToExcelSlice = createSlice({
  name: "export-to-excel",
  initialState: {
    isLoading: false,
    downloadFile: "",
    isError: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(exportToExcelApi.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(exportToExcelApi.fulfilled, (state, action) => {
      state.isLoading = false;
      state.downloadFile = action.payload;
    });
    builder.addCase(exportToExcelApi.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export default exportToExcelSlice.reducer;
